module.exports = __webpack_public_path__ + "media/login-page-bg-rzd-1920@3x.13954d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-page-bg-rzd-1920@3x.jpg
// module id = 1111
// module chunks = 62